import dayjs from 'dayjs';
import { ComputeExpressionValue } from '../../../../expressions/compute/ComputeExpression';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { IEvaluationVariables } from '../../../../expressions/evaluate/variables/IEvaluationVariables';

/**
 * Restituisce la stringa calcolata a partire dal valore dell'espressione.
 * Sostituisce tutte le variabili con il loro valore.
 */
export function hydrateComputedString(
  value: ComputeExpressionValue,
  variables: IEvaluationVariables,
) {
  return value
    .map(v => {
      // Caso standard: testo
      if (v.type === 'text') return v.text;

      // Riferimento a variabile
      if (!variables[v.attrs.reference.id]) return '';

      // Formattazione data
      if (
        v.attrs.reference.field.type === Datatype.Date &&
        variables[v.attrs.reference.id]
      ) {
        return dayjs(variables[v.attrs.reference.id]?.toString()).format(
          'DD/MM/YYYY',
        );
      }

      return String(variables[v.attrs.reference.id]);
    })
    .join('');
}
